"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _moment = _interopRequireDefault(require("moment")),
    _classnames = _interopRequireDefault(require("classnames")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _StatusBar = _interopRequireDefault(require("./StatusBar"));

require("../styles/_credits-overview.scss");

function CreditsBlock(a) {
  var b = a.title,
      c = a.balance,
      d = a.total,
      e = a.footerText,
      f = a.footerPrefix,
      g = a.footerPrefixColour,
      h = a.isUnlimited;
  return _react["default"].createElement("div", {
    className: "credits-overview__block"
  }, _react["default"].createElement(_uiKit.Text, {
    heading5: !0,
    noMargin: !0,
    className: "credits-overview__block__header"
  }, b), _react["default"].createElement(_uiKit.Text, {
    heading3: !0,
    prefixIcon: h ? "unlimited" : void 0
  }, h ? "Unlimited" : "".concat(c, " of ").concat(d)), h ? null : _react["default"].createElement(_StatusBar["default"], {
    balance: c,
    total: d
  }), _react["default"].createElement("div", {
    className: "credits-overview__block__footer"
  }, e && _react["default"].createElement(_uiKit.Text, {
    noMargin: "bottom",
    label: !0,
    prefixIcon: f,
    prefixIconColor: g,
    className: "credits-overview__block__footer__text--".concat(f)
  }, e)));
}

var getAvailableFooterProps = (0, _memoizeOne["default"])(function (a) {
  if (!a || !a.length) return {};
  var b = a[a.length - 1],
      c = a[a.length - 2],
      d = b.submissions - c.submissions;
  return 0 < d ? {
    footerPrefix: "positive",
    footerPrefixColour: "monkey",
    footerText: "".concat(Math.abs(d), " videos from last month")
  } : 0 > d ? {
    footerPrefix: "negative",
    footerPrefixColour: "redApple",
    footerText: "".concat(Math.abs(d), " videos from last month")
  } : {
    footerPrefix: "partial",
    footerPrefixColour: "russian",
    footerText: "Same videos as last month"
  };
}),
    getDaysBeforeExpiry = (0, _memoizeOne["default"])(function () {
  var a = (0, _moment["default"])().date(),
      b = (0, _moment["default"])().daysInMonth();
  return b - a + 1;
});

function CreditsOverview(a) {
  var b = a.isUnlimited,
      c = a.creditBalance,
      d = a.monthlySubmissions,
      e = a.size,
      f = a.className;
  if (!c) return null;
  var g = 400 > e.width,
      h = c.balance,
      i = c.creditTotal,
      j = c.rolloverBalance,
      k = c.rolloverTotal,
      l = g ? h + j : h,
      m = g ? i + k : i;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("credits-overview", {
      "credits-overview--unlimited": b
    }, f)
  }, _react["default"].createElement("div", {
    className: "credits-overview__inner"
  }, _react["default"].createElement(CreditsBlock, (0, _extends2["default"])({
    title: "Available Credits",
    balance: l,
    total: m,
    isUnlimited: b
  }, getAvailableFooterProps(d))), b || g ? null : _react["default"].createElement(CreditsBlock, (0, _extends2["default"])({
    title: "Rollover Credits",
    balance: j,
    total: k,
    footerText: "Expires in ".concat(getDaysBeforeExpiry(), " days")
  }, getAvailableFooterProps(d)))));
}

var _default = (0, _react.memo)(CreditsOverview);

exports["default"] = _default;